import React, { useContext } from 'react'
import { FormattedMessage, useIntl } from 'gatsby-plugin-intl'

import Pagination from 'src/components/Pagination'
import {
  BottomRow,
  Container,
  Counter,
  Ellipsis,
  EmptyOffers
} from 'src/features/stocks/components/atoms'
import LoadingList from 'src/components/atoms/LoadingList'

import Shade from 'src/components/Shade'
import { HEADERS_FINISHED } from 'src/features/myOffers/duck/consts'
import ArrowIcon from 'src/assets/icons/arrow-down.svg'
import PermissionsContext, {
  hasPermissionTo,
  PERMISSIONS
} from 'src/utils/permissions'
import { connectFreeCarrierFinished } from 'src/features/myOffers/duck/connectors'
import {
  ActionGroup,
  FreeCarrierTableHeader,
  HeaderItem,
  ListTopRow
} from 'src/features/myOffers/components/atoms'
import { Icon } from 'src/features/account/components/atoms'
import Checkbox from 'src/components/atoms/CheckboxInput'
import { BOOLEAN } from 'src/ducks/consts'
import { isStockLoading } from 'src/utils/stocks'
import Offer from './OfferRowFinished'
import {
  SearchFilter,
  SelectWrapper
} from 'src/components/filters/components/atoms'
import { REFERENCE_NUMBER_PREFIX } from 'src/features/stocks/ducks/consts'

const OffersList = ({
  finishedOffers,
  myOffers: offers,
  pagination,
  filters,
  setFilter,
  hidePagination = false
}) => {
  const headers = HEADERS_FINISHED.MY_FREE_CARRIER
  const permissions = useContext(PermissionsContext)
  const intl = useIntl()

  const hasPermissionToDeleteOwnOffer = hasPermissionTo(
    PERMISSIONS.OFFER_DELETE_OWN,
    permissions
  )

  const toggleFilter = name => {
    setFilter(name, !filters.onlyMe)
  }

  const renderListContents = () => {
    if (isStockLoading(finishedOffers, 'list')) {
      return (
        <>
          <Shade />
          <LoadingList />
        </>
      )
    }

    if (offers.length === 0) {
      return (
        <EmptyOffers>
          <FormattedMessage id='offers.noOffers' />
        </EmptyOffers>
      )
    }

    if (offers.length > 0) {
      return offers.map(offer => (
        <Offer
          key={offer.id}
          offer={offer}
          headers={headers}
          hasPermissionToDeleteOwnOffer={hasPermissionToDeleteOwnOffer}
        />
      ))
    }
  }

  return (
    <>
      <ListTopRow>
        <Counter>
          <span>{`${pagination.total} `}</span>
          <FormattedMessage
            id='offers.offersFound'
            values={{
              count: pagination.total
            }}
          />
        </Counter>
        <ActionGroup
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            flexWrap: 'nowrap'
          }}
        >
          <SelectWrapper
            style={{
              marginRight: '15px',
              flexGrow: 1,
              maxWidth: '300px'
            }}
          >
            <SearchFilter
              name='referenceNumber'
              id='input-search-free-carrier'
              initValue={REFERENCE_NUMBER_PREFIX.FREE_CARRIERS}
              filterValue={filters.referenceNumber}
              setFilter={setFilter}
              placeholder={intl.formatMessage({ id: 'common.offerNumber' })}
              style={{
                display: 'flex',
                width: '100%'
              }}
            />
          </SelectWrapper>
          <Checkbox
            name='onlyMe'
            value={filters.onlyMe}
            onChange={toggleFilter}
            option={{
              text: intl.formatMessage({ id: 'offers.onlyMe' }),
              value: BOOLEAN.YES
            }}
          />
        </ActionGroup>
      </ListTopRow>
      <Container>
        <FreeCarrierTableHeader numberOfHeaders={headers.length}>
          <HeaderItem></HeaderItem>
          {headers &&
            headers.map((header, index) => (
              <HeaderItem sort={false} key={`${header.name} ${index}`}>
                <Ellipsis>
                  <FormattedMessage id={header.name} defaultMessage=' ' />
                  {header.sort && (
                    <Icon>
                      <ArrowIcon />
                    </Icon>
                  )}
                </Ellipsis>
              </HeaderItem>
            ))}
        </FreeCarrierTableHeader>
        {renderListContents()}
      </Container>
      {offers.length > 0 && !hidePagination && (
        <BottomRow>
          <Pagination
            itemsPerPage={filters.limit}
            currentPage={pagination.currentPage}
            pagesCount={pagination.lastPage}
            setPage={page => setFilter('page', page)}
            setItemsPerPage={limit => {
              setFilter('limit', limit)
              setFilter('page', 1)
            }}
          />
        </BottomRow>
      )}
    </>
  )
}

export default connectFreeCarrierFinished(OffersList)
